import { defineMessages } from 'utils/intl';

export default defineMessages({
  addToCart: 'Dodaj do koszyka',
  askForAvailability: 'Zapytaj o dostępność',
  askForProduct: 'Zapytaj o produkt',
  infoSuccessor: 'Sprawdź informację o następcy',
  stayTuned: 'Warto poczekać!',
  prereleaseProduct: 'Produkt przedpremierowy',
});
